import React, { useEffect, useState } from 'react';
import { UserType } from '../../../../api';
import { ProfileUpComm, ProfileEventTypes } from '../ProfileData';
import { UserDataKeys } from '../UserDataKeys';
import { Checkbox } from 'react-magma-dom';
import { Card } from '../../../magma-wrap/Card';
import { SupervisorNameInput } from '../../../data-inputs/validated/SupervisorNameInput';
import { SupervisorEmailInput } from '../../../data-inputs/validated/SupervisorEmailInput';
import {
  SupervisorPhoneNumberInput
} from '../../../data-inputs/validated/SupervisorPhoneNumberInput';
import { InstitutionNameInput } from '../../../data-inputs/validated/InstitutionNameInput';
import { InstitutionCityInput } from '../../../data-inputs/validated/InstitutionCityInput';
import { InstitutionStateInput } from '../../../data-inputs/validated/InstitutionStateInput';
import { CountrySelect } from '../CountrySelect';
import { TEST_ID } from '../../../FacultyCreateProfile';
import { InstitutionPicker } from './InstitutionPicker';
import { trackingClient } from '../../../../ext/tracking';

export const InstitutionPickerCard: React.FC<ProfileUpComm> = props => {
  const {
    upComm,
  } = props;

  const hasOverrides = !!upComm?.ctx?.overrides?.hidden?.[UserDataKeys.instId];
  const [countrySelectionEnabled, setCountrySelectionEnabled] = useState(false);
  const [manualVerification, setManualVerification] = useState(false);
  const trackCategory = trackingClient.event.facultyRegistrationDetails;


  useEffect(() => {
    setManualVerification(countrySelectionEnabled);
  }, [setManualVerification, countrySelectionEnabled]);

  if (hasOverrides) {
    // Send the id
    upComm?.sendMsg({
      type: ProfileEventTypes.dataChanged,
      data: {
        key: UserDataKeys.instId,
        value: upComm?.ctx?.overrides?.values?.[UserDataKeys.instId]
      }
    });
    return <></>;
  }
 
  return (
    <Card style={{ padding: 3 }}>
      {/* Fragment used to keep Institution picker with the cannot find link */}
      <InstitutionPicker
        required={true}
        upComm={upComm}
        disabled={!!manualVerification}
        userType={UserType.instructor}
        onFocus={() => {
          trackCategory.institutionSelectionStart();
        }}
      />
      <Checkbox
        testId={TEST_ID.MANUAL_VERIFICATION_LINK}
        checked={manualVerification}
        onChange={({ target: { checked } }) => {
          setCountrySelectionEnabled(checked);
          trackCategory.manuallyValidateClick();
        }}
        labelText="I could not find my institution"
      />
      {manualVerification && (
        <span>
          <p>
            Provide more information to verify your identity as an instructor. You will not have access to Cengage
            learning materials until we can verify your identity.
          </p>
          <SupervisorNameInput upComm={upComm}/>
          <SupervisorEmailInput upComm={upComm}/>
          <SupervisorPhoneNumberInput upComm={upComm}/>
          <InstitutionNameInput upComm={upComm}/>
          <InstitutionCityInput upComm={upComm}/>
          <InstitutionStateInput upComm={upComm}/>
          <CountrySelect
            upComm={upComm}
            required={true}
            disabled={!countrySelectionEnabled}
          />
        </span>
      )}
    </Card>
  );
};
